import { create } from 'zustand';

interface EditAdminStore {
  isAdminMode: boolean;
  setIsAdminMode: (value: boolean) => void;
}

export const useAdminModeStore = create<EditAdminStore>((set) => ({
  isAdminMode: false,
  setIsAdminMode: (value) => set({ isAdminMode: value }),
}));
